import Stack from '@mui/material/Stack';
import * as React from 'react';
import { EReduxState } from '../../store/enum';
import { useAppSelector } from '../../store/hook';
import { selectResult } from '../../store/result/resultSlice';
import { CurrentScenarioContext } from '../MultiScenario';
import Input from './Input';
import Result from './Result';
import NewEngine from './engine/NewEngine';

interface IScenarioProps {}

const Scenario = (props: IScenarioProps) => {
    const result = useAppSelector(selectResult);
    const currentIndex = React.useContext(CurrentScenarioContext);

    const sxInput = result.status == EReduxState.initialState ? { width: { xs: '100%', md: '25%' } } : { width: { xs: '50%', md: '25%' } };
    const sxNewEngine =
        result.status == EReduxState.initialState
            ? { display: { xs: 'none', md: 'block' }, width: { md: '75%' } }
            : { visibility: { xs: 'hidden', md: 'visible' }, position: { xs: 'absolute', md: 'relative' }, width: { xs: '40%' } };

    return (
        <Stack height={'100%'} direction={'row'} spacing={2}>
            {result.status == EReduxState.fulfilled && (
                <Stack sx={{ width: { xs: '50%', md: '35%' } }} position='relative'>
                    <Result />
                </Stack>
            )}
            <Stack sx={sxNewEngine}>
                <NewEngine index={currentIndex} />
            </Stack>
            <Stack sx={sxInput} position='relative'>
                <Input />
            </Stack>
        </Stack>
    );
};
export default Scenario;
